var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",attrs:{"id":"Sidebar"}},[_c('el-button',{attrs:{"id":"sidebarClose","icon":"el-icon-close","circle":""},on:{"click":function($event){_vm.open=false}}}),_c('ConsentuaInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }